import React from 'react';
import { Props } from 'react-modal';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import wandIcon from 'src/assets/wand-icon.png';
import * as S from './Modal.styles';

S.Container.setAppElement('#root');

interface ModalProps extends Omit<Props, 'onRequestClose'> {
  translateX?: number;
  isLoading?: boolean;
  center?: boolean;
  noCloseIcon?: boolean;
  onRequestClose: (a: { hook?: 'cross' | 'background' }) => void;
  disableAnalytics?: boolean;
  isWizzard?: boolean;
  persistent?: boolean;
}

export const Modal: React.FC<ModalProps> = ({
  children,
  translateX = 0,
  isLoading,
  center = true,
  noCloseIcon,
  onRequestClose,
  disableAnalytics,
  isWizzard,
  persistent,
  ...other
}) => {
  const parentSelector = () => document.querySelector('#modal') as HTMLElement;

  return (
    <S.Container
      parentSelector={parentSelector}
      translateX={translateX}
      $isLoading={isLoading}
      overlayClassName={center ? 'modalOverlay-center' : 'modalOverlay'}
      shouldCloseOnOverlayClick={!persistent}
      onRequestClose={() => {
        if (persistent) return;
        onRequestClose({ hook: 'background' });
        if (!disableAnalytics) {
          mpEvent(MPEvents.ModalCanceled, {
            reason: 'background',
          });
        }
      }}
      {...other}
    >
      {!noCloseIcon && (
        <S.CloseIcon
          $disabled={persistent}
          onClick={() => {
            if (persistent) return;
            onRequestClose({ hook: 'cross' });
            if (!disableAnalytics) {
              mpEvent(MPEvents.ModalCanceled, {
                reason: 'background',
              });
            }
          }}
          data-cy="close-modal-button"
        />
      )}
      {isWizzard && (
        <div className="h-padding wizzard">
          <S.WandIcon src={wandIcon} />
        </div>
      )}
      <div className="children" data-cy="modal">
        {children}
      </div>
    </S.Container>
  );
};
